const locationSearch = typeof window !== 'undefined' ? window.location.search : '';
// eslint-disable-next-line import/prefer-default-export
export const QUERY_VERSION = new URLSearchParams(locationSearch).get('version') ?? '2.0.0';

export const IS_TIER3_PAGE = !!new URLSearchParams(locationSearch).has('isdealer');
